import React from 'react';
interface ButtonProps {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary';
  onClick?: () => void;
  className?: string;
  type?: 'button' | 'submit' | 'reset';
  ariaLabel?: string;
}
export function Button({
  children,
  variant = 'primary',
  onClick,
  className = '',
  type = 'button',
  ariaLabel
}: ButtonProps) {
  const baseStyles = 'px-6 py-3 rounded-lg font-semibold transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2';
  const variantStyles = {
    primary: 'bg-red-600 hover:bg-red-700 text-white focus:ring-red-500 shadow-md hover:shadow-lg',
    secondary: 'bg-blue-900 hover:bg-blue-800 text-white focus:ring-blue-700 shadow-md hover:shadow-lg'
  };
  return <button type={type} onClick={onClick} className={`${baseStyles} ${variantStyles[variant]} ${className}`} aria-label={ariaLabel} data-id="element-225">
      {children}
    </button>;
}